import { SvgIcon, type SvgIconProps, useTheme } from "@mui/material";

// TODO: SIM-276 repair color so that it uses theme and create other variants of icon

/**
 * Simple Logo os Sprava Zeleznic.
 * @param {SvgIconProps} props - The props from MUI icon props.
 * @component
 * @category ui
 * @subcategory feedback
 */
export const SzSimpleIcon = (props: SvgIconProps) => {
	const theme = useTheme();
	return (
		<SvgIcon transform="matrix(1,0,0,-1,0,0)" viewBox="-10 10  80.330132 101.50293" {...props}>
			<path
				style={{
					fill: (theme.vars || theme).palette.primaryColors.orange.main,
					fillOpacity: 1,
					fillRule: "nonzero",
					stroke: "none",
				}}
				d="M 60.248,67.715 H 0 v 8.413 H 60.248 Z M 0,36.801 v -8.412 h 60.248 v 8.412 H 30.054 v 1.155 c 1.744,1.183 3.453,2.389 5.202,3.566 8.125,5.465 15.144,10.186 24.992,10.186 v 8.411 H 0 V 51.708 H 33.51 V 50.537 C 32.547,49.863 31.571,49.181 30.561,48.502 21.631,42.496 13.193,36.824 0.076,36.801 Z"
			/>
		</SvgIcon>
	);
};

export default SzSimpleIcon;
